import script from "./TablePagination.vue?vue&type=script&lang=ts&setup=true"
export * from "./TablePagination.vue?vue&type=script&lang=ts&setup=true"

import "./TablePagination.vue?vue&type=style&index=0&id=2f10ac28&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f10ac28"]])

export default __exports__